import request from '@/utils/request'

const tradePreRiskControlApi = {
  trade_pre_risk_control_list: '/trade/pre_risk_control/',
  trade_pre_risk_control_create: '/trade/pre_risk_control/',
  trade_pre_risk_control_update: '/trade/pre_risk_control/',
  trade_pre_risk_control_delete: '/trade/pre_risk_control/',
  trade_pre_risk_control_send: '/trade/pre_risk_control/',
  trade_pre_risk_control_attachment: '/trade/pre_risk_control_attachment/',
  trade_in_process_risk_control: '/trade/in_process_risk_control/',
  trade_in_process_risk_control_items: '/trade/in_process_risk_control_items/',
  trade_in_process_risk_control_send: '/trade/in_process_risk_control/',
  trade_in_process_risk_control_items_attachments: '/trade/in_process_risk_control_items_attachments/'
}

/**
 * 列表
 */
export function pre_risk_control_list (parameter) {
  return request({
    url: tradePreRiskControlApi.trade_pre_risk_control_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function pre_risk_control_create (parameter) {
  return request({
    url: tradePreRiskControlApi.trade_pre_risk_control_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function pre_risk_control_update (parameter, pre_risk_control_id) {
  return request({
    url: tradePreRiskControlApi.trade_pre_risk_control_update + pre_risk_control_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function pre_risk_control_delete (pre_risk_control_id) {
  return request({
    url: tradePreRiskControlApi.trade_pre_risk_control_delete + pre_risk_control_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function pre_risk_control_attachment_list (parameter) {
  return request({
    url: tradePreRiskControlApi.trade_pre_risk_control_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

export function pre_risk_control_attachment_create (parameter) {
  return request({
    url: tradePreRiskControlApi.trade_pre_risk_control_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

export function pre_risk_control_attachment_delete (id) {
  return request({
    url: tradePreRiskControlApi.trade_pre_risk_control_attachment + id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 列表
 */
export function in_process_risk_control_list (parameter) {
  return request({
    url: tradePreRiskControlApi.trade_in_process_risk_control,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function in_process_risk_control_create (parameter) {
  return request({
    url: tradePreRiskControlApi.trade_in_process_risk_control,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function in_process_risk_control_update (parameter, risk_control_id) {
  return request({
    url: tradePreRiskControlApi.trade_in_process_risk_control + risk_control_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function in_process_risk_control_delete (risk_control_id) {
  return request({
    url: tradePreRiskControlApi.trade_in_process_risk_control + risk_control_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 删除
 */
export function in_process_risk_control_items_list (parameter) {
  return request({
    url: tradePreRiskControlApi.trade_in_process_risk_control_items,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 添加
 */
export function in_process_risk_control_items_create (parameter) {
  return request({
    url: tradePreRiskControlApi.trade_in_process_risk_control_items,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

export function in_process_risk_control_items_update (parameter, item_id) {
  return request({
    url: tradePreRiskControlApi.trade_in_process_risk_control_items + item_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function in_process_risk_control_items_delete (item_id) {
  return request({
    url: tradePreRiskControlApi.trade_in_process_risk_control_items + item_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function pre_risk_control_send (parameter, id) {
  return request({
    url: tradePreRiskControlApi.trade_pre_risk_control_send + id + '/send/',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

export function in_process_risk_control_send (parameter, id) {
  return request({
    url: tradePreRiskControlApi.trade_in_process_risk_control_send + id + '/send/',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 获取附件列表
 */
export function in_process_risk_control_items_attachments_list (parameter) {
  return request({
    url: tradePreRiskControlApi.trade_in_process_risk_control_items_attachments,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 删除附件
 */
export function in_process_risk_control_items_attachments_create (data) {
  return request({
    url: tradePreRiskControlApi.trade_in_process_risk_control_items_attachments,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })
}

/**
 * 删除附件
 */
export function in_process_risk_control_items_attachments_delete (id) {
  return request({
    url: tradePreRiskControlApi.trade_in_process_risk_control_items_attachments + id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
